<template>
  <div class="">
    <div id="top" class="py-20 relative block">
      <div class="max-w-4xl mx-auto px-5">
        <div class="font-bold">
          <div class="font-bold text-xl">
            <p class="text-5xl">CSSNLP 2020</p>
            <p>第一届中国自然语言处理学生研讨会</p>
            <p class="text-gray-600">
              The China Student Symposium on Natural Language Processing
            </p>
            <p class="mt-2">2020年12月26-27日</p>
          </div>
          <div class="mt-10 flex flex-col space-y-1 text-lg">
            <p>
              <span>主办单位：</span>
              <span
                ><a
                  class="text-blue-800 hover:text-blue-600"
                  href="http://www.cipsc.org.cn/qngw/"
                  >中文信息学会青年工作委员会</a
                >
              </span>
            </p>
            <p>
              <span>社区支持：</span>
              <span
                ><a
                  class="text-blue-800 hover:text-blue-600"
                  href="http://hub.baai.ac.cn/"
                  >智源社区</a
                >
              </span>
            </p>
          </div>
          <div class="mt-10 flex flex-col font-bold text-base">
            <div class="flex flex-wrap space-x-6">
              <a
                class="text-gray-700"
                href="https://hub.baai.ac.cn/activity/details/121"
                >线下会议报名</a
              >
              <span class="border-l border-gray-500"></span>
              <a
                class="text-gray-700"
                href="https://zoom.com.cn/j/81965206120"
                >Zoom链接</a
              >
              <a
                class="text-gray-700"
                href="https://live.bilibili.com/21484823"
                >B站直播</a
              >
              <span class="border-l border-gray-500"></span>
              <a
                class="text-blue-700 hover:text-blue-600"
                href="https://www.bilibili.com/video/BV1E54y1x7om"
                >
                <font-awesome-icon :icon="['far', 'play-circle']"
                      />
                在线回放</a
              >
            </div>
            <!-- <div class="text-xs text-gray-600 mt-1">
              <p>*线下报名截止日期：2020年12月25日12:00</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="px-5 py-20 border-b">
      <div class="max-w-4xl mx-auto">
        <p class="text-3xl font-bold text-center">CSSNLP 2020</p>
        <p
          class="indent-sm mt-5 text-lg sm:text-xl leading-relaxed sm:leading-loose"
        >
          中国自然语言处理学生研讨会（The China Student Symposium on Natural
          Language Processing, CSSNLP
          2020）将于2020年12月26日-12月27日在北京首次举办。会议主办单位为中国中文信息学会（CIPS）青年工作委员会，会议地点在北京智源人工智能研究院。本次会议为第一届中国自然语言处理学生研讨会，包含特邀报告、前沿主题讲习班、博士生论坛、COLING
          论文和 EMNLP
          论文报告五个环节，主要目的是为自然语言处理研究领域内的中国青年学者提供一个学术交流平台。同时鼓励更多的青年学者关注自然语言处理前沿研究，展示最新科研成果，促进国内青年学者的思想交流和学术合作，进而推动自然语言处理在中国的发展。本次
          CSSNLP 2020
          将线下线上同时举行，线下可通过注册进行参会，线上通过视频直播对外开放。
        </p>
      </div>
    </div>
    <div class="px-5 py-20 border-b">
      <div class="max-w-4xl mx-auto">
        <div class="flex justify-between flex-wrap sm:space-x-10 space-x-0 space-y-10 sm:space-y-0">
          <div class="sm:flex-1">
            <p class="text-2xl font-bold">友情提示</p>
            <ul class="leading-relaxed text-lg sm:text-xl list-disc ml-6 mt-2">
              <!-- <li class="font-bold">现场参会福利，有丰富礼品（U盘+日历）</li>
              <li class="font-bold">QA提问福利，送精美技术图书等</li> -->
              <li>由于会议现场席位有限，名额先到先得，报满截止。</li>
              <li class="font-bold">线下报名截止日期：2020年12月25日 12:00。</li>
              <li>现场观众签到时间：2020年12月26日 08:00-08:40。</li>
              <li>
                由于参会报名在12月26日之前持续进行，我们将依据报名的实时情况，分批发放与会邀请通知（成功报名通知）；如若名额已满，我们也将向相关报名人员发放通知告知情况。还请大家报名后耐心等待。
              </li>
              <li>本次会议免费注册，对于受邀参会人员，全程食宿自理。</li>
            </ul>
          </div>
          <div class="w-64 flex-shrink-0">
            <img class="w-full" src="@/assets/images/wechat.png" alt="" />
            <p class="text-center mt-3 text-sm text-gray-700">
              CSSNLP 2020参会者微信交流群
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="px-5 py-20 border-b">
      <div class="max-w-4xl mx-auto">
        <div class="text-base">
          <p class="text-2xl font-bold">疫情防控要求</p>
          <ul class="leading-relaxed text-lg sm:text-xl list-disc ml-6 mt-2">
            <li>
              因常态化疫情防控要求，参会人员请主动接受配合体温检测、健康宝查验，体温检测正常，凭健康宝“绿码”参会。进入室内会场等密闭场所应全程佩戴口罩，保持安全社交距离。
            </li>
            <li>
              参会人员健康宝出现“黄码”、“橙码“与“红码”，一律不得进入会场，敬请谅解。
            </li>
            <li>
              参会人员出现异常症状，应主动报告并配合工作人员接受流行病学调查和相应的处置措施。
            </li>
            <li>
              出于对于新冠疫情的防控，出行期间和公众场所，要保持自我防护意识，坚持科学正确戴口罩。本次会议嘉宾、讲者、参会者等请全程佩戴口罩，未戴口罩者将无法进入会场，且入场时需出示健康码。
            </li>
            <li class="font-bold text-red-800">本次会议不接受非在京人士参会。</li>
            <li class="font-bold">
              特别提示：为方便查验、减少排队时间，请大家提前验证并获取健康宝。
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="px-5">
      <div class="max-w-4xl mx-auto py-20 flex justify-center">
        <div class="w-64" id="counter-wrap"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: "首页"
  },
  data() {
    return {};
  },
  mounted() {
    let counter = document.createElement('script');
    counter.setAttribute(
      'src',
      '//cdn.clustrmaps.com/map_v2.js?cl=374151&w=a&t=tt&d=mOfj_I4mAXJ5cBjcHnyKHLP4NTVu8_V5M-jRInrcB10&co=ffffff&cmo=3acc3a&cmn=ff5353&ct=6b7280'
    );
    counter.setAttribute('id', 'clustrmaps');
    document.getElementById('counter-wrap').appendChild(counter);
  },
  computed: {},
};
</script>

<style>
.indent-sm {
  text-indent: 2rem;
}
.indent-md {
  text-indent: 3rem;
}
.indent-lg {
  text-indent: 4rem;
}
#top::after {
  content: '';
  background-image: url(http://bj.bcebos.com/qngw2014/images/2014/03/NaTgyVpp90U6Fbk.jpg);
  opacity: 0.1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  /* background-attachment: fixed; */
  background-size: cover;
  background-position: center;
}
</style>